module.exports = __webpack_public_path__ + "./fonts/InterTight-SemiBoldItalic.ttf";